export const ADVANCED_ABORT_CONTROLLER_PRIVATE = Symbol('advanced-abort-controller-private');
//# sourceMappingURL=privates.js.map